// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MinimizeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MinimizeIcon" ref={forwardedRef} {...props}>
      <path d="M6.5 12.5 3 16l1.06 1.06 3.44-3.439V17H9v-6H3v1.5z" />
      <path d="M11 9V3h1.5v3.379l3.44-3.44L17 4l-3.5 3.5H17V9z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MinimizeIcon = /* @__PURE__ */ Object.assign(
  MinimizeIconComponent,
  { displayName: 'MinimizeIcon' },
);
